export default __webpack_public_path__ + "static/media/supabase-logo.c328a6db.svg";